var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 22,
    viewBox: "0 0 44 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.25C8.08579 10.25 7.75 10.5858 7.75 11C7.75 11.4142 8.08579 11.75 8.5 11.75L8.5 10.25ZM36.0303 11.5303C36.3232 11.2374 36.3232 10.7626 36.0303 10.4697L31.2574 5.6967C30.9645 5.40381 30.4896 5.40381 30.1967 5.6967C29.9038 5.98959 29.9038 6.46447 30.1967 6.75736L34.4393 11L30.1967 15.2426C29.9038 15.5355 29.9038 16.0104 30.1967 16.3033C30.4896 16.5962 30.9645 16.5962 31.2574 16.3033L36.0303 11.5303ZM8.5 11.75L35.5 11.75L35.5 10.25L8.5 10.25L8.5 11.75Z",
    fill: "#C7C7CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrow);
export default __webpack_public_path__ + "static/media/line_arrow.5b6d5f6e9cdacc2d822f67d66fa161c7.svg";
export { ForwardRef as ReactComponent };